module.exports = __webpack_public_path__ + "img/icn_facebook_org.e021ea69.svg";